import { render, staticRenderFns } from "./DraggableTreeview.vue?vue&type=template&id=68f5933e&scoped=true&"
import script from "./DraggableTreeview.vue?vue&type=script&lang=js&"
export * from "./DraggableTreeview.vue?vue&type=script&lang=js&"
import style0 from "./DraggableTreeview.vue?vue&type=style&index=0&id=68f5933e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f5933e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCheckbox,VCol,VRow,VTooltip})
